import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "title", "list", "searchInput"]
  static values = {
    domainUuid: String,
    topicId: String,
    topicName: String
  }

  connect() {
    this.searchTimeout = null
  }

  open(event) {
    event.preventDefault()

    const { topicId, topicName } = event.currentTarget.dataset
    this.topicIdValue = topicId
    this.topicNameValue = topicName

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = topicName
    }

    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = ""
    }

    if (this.hasModalTarget && !this.modalTarget.open) {
      this.modalTarget.showModal()
    }

    this.loadKeywords(1)
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }
    if (this.hasModalTarget && this.modalTarget.open) {
      this.modalTarget.close()
    }
  }

  search() {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => this.loadKeywords(1), 250)
  }

  loadPage(event) {
    event.preventDefault()
    const page = parseInt(event.currentTarget.dataset.page, 10) || 1
    this.loadKeywords(page)
  }

  toggleKeyword(event) {
    const checkbox = event.target
    const keywordId = checkbox.dataset.keywordId
    const assigned = checkbox.checked

    if (!keywordId) return

    checkbox.disabled = true

    fetch(this.updateKeywordUrl(keywordId), {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": this.csrfToken()
      },
      body: JSON.stringify({ assigned })
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to update keyword")
        }
      })
      .catch(() => {
        checkbox.checked = !assigned
      })
      .finally(() => {
        checkbox.disabled = false
      })
  }

  loadKeywords(page) {
    if (!this.topicIdValue || !this.domainUuidValue) return

    const query = this.hasSearchInputTarget ? this.searchInputTarget.value.trim() : ""
    const params = new URLSearchParams({ page })
    if (query) params.set("query", query)

    fetch(`${this.keywordsUrl()}?${params.toString()}`, {
      headers: { "Accept": "text/html" }
    })
      .then((response) => response.text())
      .then((html) => {
        if (this.hasListTarget) {
          this.listTarget.innerHTML = html
        }
      })
      .catch(() => {})
  }

  keywordsUrl() {
    return `/project/${this.domainUuidValue}/topics/${this.topicIdValue}/keywords`
  }

  updateKeywordUrl(keywordId) {
    return `/project/${this.domainUuidValue}/topics/${this.topicIdValue}/keywords/${keywordId}`
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta ? meta.content : ""
  }
}
